enum FrequencyType {
  HOURLY = "1 hours",
  DAILY = "1 days",
  WEEKLY = "7 days",
  MONTHLY = "30 days",
}

export default FrequencyType;
